import { AnswerType, ICategory } from "../models";

export const round96: ICategory[] = [
	{
		id: "1qxjj0ek1sccaie",
		name: "Cartons",
		answers: [
			{
				id: "1qxjj0ek1sccaij",
				type: AnswerType.TEXT,
				answer: "A cartoon about a sponge in the ocean.",
				question: "What is SpongeBob SquarePants?",
				explanation: "",
				points: 100,
				show: false,
				answered: false
			},
			{
				id: "1qxjj0ek1sccaio",
				type: AnswerType.TEXT,
				answer: "A show about a little boy who has Fairy God parents.",
				question: "What is The Fairly Odd Parents?",
				explanation: "",
				points: 200,
				show: false,
				answered: false
			},
			{
				id: "1qxjj0ek1sccait",
				type: AnswerType.TEXT,
				answer: "A show about ponies and friendship. ",
				question: "What is My Little Pony Friendship is Magic?",
				explanation: "",
				points: 300,
				show: false,
				answered: false
			},
			{
				id: "1qxjj0ek1sccaiy",
				type: AnswerType.TEXT,
				answer: "A show about 3 super powered girls fighting crime.",
				question: "What is The Power Puff Girls?",
				explanation: "",
				points: 400,
				show: false,
				answered: false
			},
			{
				id: "1qxjj0ek1sccaj3",
				type: AnswerType.TEXT,
				answer: "An older show about a Samurai fighting to save the world from robots.",
				question: "What is Samurai Jack?",
				explanation: "",
				points: 500,
				show: false,
				answered: false
			}
		]
	},
	{
		id: "1qxjj0ek1sccaif",
		name: "Popular Board games",
		answers: [
			{
				id: "1qxjj0ek1sccaik",
				type: AnswerType.TEXT,
				answer:
					"A game in which you are a entrepreneur buying properties in order to expand your wealth. ",
				question: "What is Monopoly? ",
				explanation: "",
				points: 100,
				show: false,
				answered: false
			},
			{
				id: "1qxjj0ek1sccaip",
				type: AnswerType.TEXT,
				answer:
					"A game about bringing all your pawns home,it is remembered for its iconic saying when you screw someone over. ",
				question: "What is Sorry?",
				explanation: "",
				points: 200,
				show: false,
				answered: false
			},
			{
				id: "1qxjj0ek1sccaiu",
				type: AnswerType.TEXT,
				answer:
					"A game about losing all your cards by playing the same number or color down on a discard pile.",
				question: "What is Uno?",
				explanation: "",
				points: 300,
				show: false,
				answered: false
			},
			{
				id: "1qxjj0ek1sccaiz",
				type: AnswerType.TEXT,
				answer: "A classic game about finding a murderer through searching a house.",
				question: "What is Clue?",
				explanation: "",
				points: 400,
				show: false,
				answered: false
			},
			{
				id: "1qxjj0ek1sccaj4",
				type: AnswerType.TEXT,
				answer:
					"A game about through the process of elimination finding out which character your opponent is",
				question: "What is Guess Who?",
				explanation: "",
				points: 500,
				show: false,
				answered: false
			}
		]
	},
	{
		id: "1qxjj0ek1sccaig",
		name: "Minecraft",
		answers: [
			{
				id: "1qxjj0ek1sccail",
				type: AnswerType.TEXT,
				answer: "A famous mod due to its green skin and explosive property.\n ",
				question: "What is the Creeper?",
				explanation: "",
				points: 100,
				show: false,
				answered: false
			},
			{
				id: "1qxjj0ek1sccaiq",
				type: AnswerType.TEXT,
				answer: "The bosses in vanilla minecraft. ",
				question: "What is the ender dragon and the wither?",
				explanation: "",
				points: 200,
				show: false,
				answered: false
			},
			{
				id: "1qxjj0ek1sccaiv",
				type: AnswerType.TEXT,
				answer: "A mineral used to carry electric charge.",
				question: "What is Redstone?",
				explanation: "",
				points: 300,
				show: false,
				answered: false
			},
			{
				id: "1qxjj0ek1sccaj0",
				type: AnswerType.TEXT,
				answer: "The rarest mineral found underground.",
				question: "What is Emerald? ",
				explanation: "",
				points: 400,
				show: false,
				answered: false
			},
			{
				id: "1qxjj0ek1sccaj5",
				type: AnswerType.TEXT,
				answer: "DOUBLE JEPORDY!!!The CURRANT CEO of minecraft.",
				question: "Who is Jeb or Jens?",
				explanation: "",
				points: 500,
				show: false,
				answered: false
			}
		]
	},
	{
		id: "1qxjj0ek1sccaih",
		name: "Food",
		answers: [
			{
				id: "1qxjj0ek1sccaim",
				type: AnswerType.TEXT,
				answer: "A Main food group including meat and beans.",
				question: "What is Protein? ",
				explanation: "",
				points: 100,
				show: false,
				answered: false
			},
			{
				id: "1qxjj0ek1sccair",
				type: AnswerType.TEXT,
				answer: "A item baked in a oven normally round by itself.",
				question: "What is Cake?",
				explanation: "",
				points: 200,
				show: false,
				answered: false
			},
			{
				id: "1qxjj0ek1sccaiw",
				type: AnswerType.TEXT,
				answer: "Comes from the inside of trees then is turned into this through heating. ",
				question: "What is Maple syrup?\n",
				explanation: "",
				points: 300,
				show: false,
				answered: false
			},
			{
				id: "1qxjj0ek1sccaj1",
				type: AnswerType.TEXT,
				answer: "A food made by obtaining this bean and adding hot water.",
				question: "What is Coffee?",
				explanation: "",
				points: 400,
				show: false,
				answered: false
			},
			{
				id: "1qxjj0ek1sccaj6",
				type: AnswerType.TEXT,
				answer:
					"A Grow able type of food with a hard outside and the edible portion on the inside. ",
				question: "What is Goren.",
				explanation: "",
				points: 500,
				show: false,
				answered: false
			}
		]
	},
	{
		id: "1qxjj0ek1sccaii",
		name: "Video Game Characters",
		answers: [
			{
				id: "1qxjj0ek1sccain",
				type: AnswerType.TEXT,
				answer: "A fat Italian plumber's pet.  ",
				question: "What is Yoshi?",
				explanation: "",
				points: 100,
				show: false,
				answered: false
			},
			{
				id: "1qxjj0ek1sccais",
				type: AnswerType.TEXT,
				answer: "A famous hero who wears green, A.K.A the Hero of Time.",
				question: "Who is Link?",
				explanation: "",
				points: 200,
				show: false,
				answered: false
			},
			{
				id: "1qxjj0ek1sccaix",
				type: AnswerType.TEXT,
				answer:
					"A Female character genitally modified with bird D.N.A  welding a charge up ion cannon.",
				question: "Who is Samus Aran?",
				explanation: "",
				points: 300,
				show: false,
				answered: false
			},
			{
				id: "1qxjj0ek1sccaj2",
				type: AnswerType.TEXT,
				answer: "A pink character who can suck enemies up and gain their abilities.  ",
				question: "Who is Kirby?",
				explanation: "",
				points: 400,
				show: false,
				answered: false
			},
			{
				id: "1qxjj0ek1sccaj7",
				type: AnswerType.TEXT,
				answer: "A Humanoid robot wearing blue fighting an insane doctor.  ",
				question: "Who is Megaman? ",
				explanation: "",
				points: 500,
				show: false,
				answered: false
			}
		]
	}
];
